import { render, staticRenderFns } from "./DetailedArticle.vue?vue&type=template&id=dacb7b16&scoped=true&"
import script from "./DetailedArticle.vue?vue&type=script&lang=js&"
export * from "./DetailedArticle.vue?vue&type=script&lang=js&"
import style0 from "./DetailedArticle.vue?vue&type=style&index=0&id=dacb7b16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacb7b16",
  null
  
)

export default component.exports